import React, { Fragment } from 'react';
import { Formik, Form, Field } from 'formik';
import { Link } from 'react-router-dom';
import { TextField } from 'formik-material-ui';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Box, Grid } from '@material-ui/core';

import { forgotPassword } from '../../../services/auth.service';
import { toastError, toastSuccess } from '../../../utils/globals.utils';
import { forgotPasswordSchema } from '../../../utils/forms/validators/schemaValidators.yup';
import {
	EMAILNOTEXIST,
	REQUIREDCODE,
	SUCCESSCODE,
} from '../../../utils/constants';

import { useAuthStyles } from '../auth.style';
import logo from '../../../assets/images/ctdent_logo.png';
import authImage from '../../../assets/images/authImage.jpg';

const ForgotPassword = () => {
	const { t } = useTranslation();
	const classes = useAuthStyles();

	const [loading, setLoading] = React.useState(false);

	const formInitialValues = {
		email_1: '',
	};

	const forgotPasswordSubmit = (values, { setSubmitting }) => {
		setTimeout(() => {
			setSubmitting(false);
			setLoading(true);
			forgotPassword(values).then((res) => {
				setLoading(false);
				toastSuccess(t('commonMessage.resetPasswordLinkSend'));
			});
		}, 500);
	};

	return (
		<Fragment>
			<Grid item xs={false} md={6} className={classes.image}>
				<img src={logo} alt="" className={classes.logo} />
				<img src={authImage} alt="" className={classes.aiImage} />
				<Box className={classes.info}>
					<Typography variant="h2" className={classes.heading}>
						Wise Dentists
					</Typography>
					<Typography variant="h2" className={classes.subHeading}>
						Choose AI
					</Typography>
				</Box>
			</Grid>
			<Grid
				container
				item
				xs={12}
				lg={6}
				component={Paper}
				elevation={6}
				square
				alignItems="center"
				justifyContent="center"
				style={{ background: '#F4F4F4', boxShadow: 'unset' }}
			>
				<Paper className={classes.forgotPassPaper}>
					<Box
						display="flex"
						justifyContent="flex-start"
						alignItems="center"
						mb="26px"
						width="100%"
					>
						<Typography className={classes.loginHeading}>
							<span>Reset Password</span>
						</Typography>
					</Box>
					<Formik
						initialValues={formInitialValues}
						validationSchema={forgotPasswordSchema(
							t('forms.validators.required'),
						)}
						onSubmit={forgotPasswordSubmit}
					>
						{({ submitForm, isValid, dirty, setFieldValue }) => {
							return (
								<Form className={classes.form}>
									<Typography className={classes.inputLabel} align="left">
										Enter the email address you have signed up with
									</Typography>
									<Field
										autoFocus
										size="small"
										variant="outlined"
										margin="normal"
										required
										fullWidth
										id="email"
										placeholder="Email or user name"
										name="email_1"
										autoComplete="email"
										component={TextField}
										onChange={(event) => {
											if (event.target.value?.length > 40) return;
											setFieldValue('email_1', event.target.value);
										}}
									/>

									<Button
										fullWidth
										variant="contained"
										color="primary"
										className={classes.submit}
										onClick={submitForm}
										disabled={!(dirty && isValid)}
									>
										Send
									</Button>
								</Form>
							);
						}}
					</Formik>
					<Grid container alignItems="center" justifyContent="center">
						<Grid item>
							<Link
								to="/auth/sign-in"
								variant="body2"
								className={classes.signUp}
							>
								Back to login
							</Link>
						</Grid>
					</Grid>
				</Paper>
			</Grid>
		</Fragment>
	);
};

export default ForgotPassword;
